export const TRASHED_STATUS = 'trashed' as const;
export const ARCHIVED_STATUS = 'archived' as const;

export const DEFAULT_PAGE_LIST = { values: [], total: 0 };

/* sort keys */
export const TITLE = 'title' as const;
export const CREATOR = 'creator' as const;
export const LEAD = 'lead' as const;
export const STATUS_CHANGED_TIMESTAMP = 'statusChangedTimestamp' as const;
export const NO_JSW_ACCESS_FOR_USER = 'no-jira-software-access-for-user';
